"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInfiniteQuery = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _ramda = require("ramda");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useInfiniteQuery = function useInfiniteQuery(endpoint, initialState, options) {
  var optionsRef = (0, _react.useRef)(_objectSpread(_objectSpread({}, options), {}, {
    initialState: initialState
  }));
  var shouldResetQueryState = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(initialState),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _endpoint$useLazyQuer = endpoint.useLazyQuery({
    refetchOnFocus: options.refetchOnFocus,
    refetchOnReconnect: options.refetchOnReconnect
  }),
      _endpoint$useLazyQuer2 = (0, _slicedToArray2["default"])(_endpoint$useLazyQuer, 2),
      trigger = _endpoint$useLazyQuer2[0],
      lastResult = _endpoint$useLazyQuer2[1];

  var data = lastResult.data;
  (0, _react.useEffect)(function () {
    if (data) {
      setState(function (currentState) {
        var nextState = optionsRef.current.combineResponse((0, _ramda.clone)(shouldResetQueryState.current ? optionsRef.current.initialState : currentState), data);
        shouldResetQueryState.current = false;
        return nextState;
      });
    }
  }, [data]);
  var fetchNext = (0, _react.useCallback)(function (argOrCb) {
    var triggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setState(function (currentState) {
      trigger(argOrCb instanceof Function ? argOrCb(currentState) : argOrCb, triggerOptions === null || triggerOptions === void 0 ? void 0 : triggerOptions.preferCacheValue);
      shouldResetQueryState.current = (triggerOptions === null || triggerOptions === void 0 ? void 0 : triggerOptions.resetState) || false;
      return currentState;
    });
  }, [trigger]);
  var handleSetState = (0, _react.useCallback)(function (nextStateOrCb) {
    setState(function (currentState) {
      if (nextStateOrCb instanceof Function) {
        return nextStateOrCb(currentState);
      }

      return nextStateOrCb;
    });
  }, []);
  return {
    fetchNext: fetchNext,
    queryState: state,
    setQueryState: handleSetState,
    isUninitialized: lastResult.isUninitialized,
    isLoading: lastResult.isLoading,
    isFetching: lastResult.isFetching,
    isError: lastResult.isError,
    isSuccess: lastResult.isSuccess,
    data: lastResult.data
  };
};

exports.useInfiniteQuery = useInfiniteQuery;